import React, { forwardRef, memo } from "react";
import ReactSelect, { mergeStyles, Props } from "react-select";
import DropdownIndicator from "./dropdownIndicator";
import { selectStyles } from "./selectStyles";
import Skeleton from "../skeleton";
import classes from "./selectAsync.module.scss";

export type SelectProps = Props<any, boolean> & {
	loading?: boolean;
	loaderClassName?: string;
	brandingColor?: boolean;
};

const Select = forwardRef<any, SelectProps>(
	(
		{
			loading,
			disableSkeleton,
			styles: customSelectStyles = {},
			components: customComponents = {},
			...props
		},
		ref,
	) => {
		const styles = mergeStyles(selectStyles, customSelectStyles);

		const components = {
			DropdownIndicator,
			...customComponents,
		};

		return (
			<div className={classes.selectLoaderContainer}>
				{loading && !disableSkeleton && (
					<Skeleton
						height="34px"
						className={classes.selectLoaderContainerSceleton}
					/>
				)}
				<ReactSelect
					ref={ref}
					className="react-select-container"
					classNamePrefix="react-select"
					styles={styles}
					components={components}
					{...props}
				/>
			</div>
		);
	},
);

export default memo(Select);
